import { BaseService } from "core/services";
import { DocumentFormRouteService } from "application/tracking-case/services";

class DocumentFormService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DocumentFormRouteService());
    }
}

export default DocumentFormService;